<template>
  <SideNav />

  <header>
    <div
      id="carouselExampleControls"
      class="carousel slide"
      data-bs-ride="carousel"
    >
      <div class="carousel-inner">
        <div class="carousel-item">
          <div
            class="page-header min-vh-60"
            style="background-image: url('assets/img/bmms5.jpg');"
            loading="lazy"
          >
            <span class="mask bg-gradient-bmms  opacity-6" />
            <div class="container">
              <div class="row">
                <div class="col-lg-6 my-auto pt-4 px-5  p-md-6">
                  <h5 class="fadeIn1 fadeInBottom text-white">
                    一眼掌握雲端園區 監控管理好幫手
                  </h5>
                  <h2 class="mb-4 fadeIn2 fadeInBottom text-white ">
                    創益圖Tron Map
                  </h2>
                  <p class="fadeIn3 fadeInBottom text-white text-xl">
                    昀揚科技股份有限公司將於 2024 年 Q1 推出創益圖 Tron Map，
                    近年來掌握「使用者應用生態圈」、透過以人為本的使用者行為與需求，結合智慧科技來創造最高價值的產業紛紛興起，
                    在這一波智慧科技驅動資通訊產業的革命潮流中，
                    為「園區管理」開啟了雲端化的新視野。<br>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>           
        <div class="carousel-item">
          <div
            class="page-header min-vh-60"
            style="background-image: url('assets/img/tronedu.jpg');"
            loading="lazy"
          >
            <span class="mask bg-gradient-black opacity-5" />
            <div class="container">
              <div class="row">
                <div class="col-lg-6 my-auto pt-4 px-5  p-md-6">
                  <h5 class="fadeIn1 fadeInBottom text-white">
                    雲端教材智慧整合 為業界提供最佳選擇
                  </h5>
                  <h2 class="mb-4 fadeIn2 fadeInBottom text-white">
                    TronEdu創益學
                  </h2>
                  <p class="fadeIn3 fadeInBottom text-white text-xl ">
                    昀揚科技股份有限公司將於 2024 年 Q1 推出 TronEdu 創益學平台（Curriculum Platform） 其擁有「智能雲端課程編排系統」、「智能出卷系統」、「智能排課系統」等人工智能應用相關獨家專利技術，
                    使用者可透過昀揚科技的雲端資料中心更新教育部公佈每年最新版的知識架構與課綱，亦可應用在專業證照、教育訓練、高普考、幼兒等需求，客製化知識架構及課綱。
                    數位管理有效為使用者解決不同課程版本無法統一教材內容而造成巨額維護成本與時間的難題。<br>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>        
        <div class="carousel-item active">
          <div
            class="page-header min-vh-60"
            style="background-image: url('assets/img/security2.jpg');"
            loading="lazy"
          >
            <span class="mask bg-gradient-black opacity-3" />
            <div class="container">
              <div class="row">
                <div class="col-lg-6 my-auto pt-4 px-5  p-md-6">
                  <h5 class="fadeIn1 fadeInBottom text-white">
                    2023臺灣數位信任科技應用交流會
                  </h5>
                  <h2 class="mb-4 fadeIn2 fadeInBottom text-white">
                    TronSecurity
                  </h2>
                  <p class="fadeIn3 fadeInBottom text-white text-xl">
                    昀揚科技股份有限公司將於 2024 年 Q1 推出「創益Security（TronSecurity）」資訊安全的解決方案，
                    與工研院資安整合服務平台（Security Platform as a Services , SECPAAS）以及歐生全 AuthenTrend三方進行技術轉移合作，
                    提供使用者建立零信任架構（ZTA）中決策引擎「身分鑑別」的核心機制。<br>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>         
        <div class="carousel-item">
          <div
            class="page-header min-vh-60"
            style="background-image: url('assets/img/class.jpg');"
            loading="lazy"
          >
            <span class="mask bg-gradient-black opacity-5" />
            <div class="container">
              <div class="row">
                <div class="col-lg-7 my-auto pt-4 px-5  p-md-6">
                  <h5 class="fadeIn1 fadeInBottom text-white">
                    翻轉未來智慧教育
                  </h5>
                  <h2 class="mb-2 mb-md-4 fadeIn2 fadeInBottom text-white">
                    無邊界學習 Smart Schools
                  </h2>
                  <p class="fadeIn3 fadeInBottom text-white mb-0 text-xl">
                    為培養學生成為未來人才，符應十二年國民基本教育課程綱要精 神，學生必須具備數位素養、創新能力、工作與生活能力，因此，新北市將以四年時間打造「未來智慧學校」，提升適性學習品質，並以全方位的資訊系統平臺服務學校、教師、家長與學生，滿足多元化的教育需求，揚升教與學之便利性及學校行政效能
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>          
        <div class="carousel-item">
          <div
            class="page-header min-vh-60"
            style="background-image: url('assets/img/crs.jpg');"
            loading="lazy"
          >
            <span class="mask bg-gradient-black opacity-4" />
            <div class="container">
              <div class="row">
                <div class="col-lg-7 my-auto pt-4 px-5  p-md-6">
                  <h5 class="fadeIn1 fadeInBottom text-white">
                    影音串流媒體服務開發與整合的最佳解決方案
                  </h5>
                  <h2 class="mb-2 mb-md-4 fadeIn2 fadeInBottom text-white">
                    CRStream Standard
                  </h2>
                  <p class="fadeIn3 fadeInBottom text-white mb-0 text-xl">
                    昀揚科技於今年6月推出的CRStream Standard是一套針對影音串流媒體服務開發與整合所設計的最佳解決方案，其中包含CRStream Convert影音轉檔工具和CRStream API影音管理系統以及提供全載具（手機、平板、電腦、智能電視）播放SDK，使用者可以運用本系統快速建置及擴展高效穩定的影音串流媒體服務。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item">
          <div
            class="page-header min-vh-60"
            style="background-image: url('assets/img/user.jpg');"
            loading="lazy"
          >
            <span class="mask bg-gradient-black opacity-5" />
            <div class="container">
              <div class="row">
                <div class="col-lg-7 my-auto pt-4 px-5  p-md-6">
                  <h5 class="fadeIn1 fadeInBottom text-white">
                    教育科技
                  </h5>
                  <h3 class="mb-2 mb-md-4 fadeIn2 fadeInBottom text-white">
                    TronEdu EMS Essentials Plus<br>解決命題煩惱
                  </h3>
                  <p class="fadeIn3 fadeInBottom text-white mb-0 text-xl">
                    採用標準化的RESTful API風格架構和容器化微服務架構，用積累數年K12教育科技整合的豐富經驗，為老師和編輯人員處理命題、出卷、考試、分析、診斷等資訊應用服務，一次性解決您所有的命題煩惱。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item">
          <div
            class="page-header min-vh-60"
            style="background-image: url('assets/img/bg9.jpg');"
            loading="lazy"
          >
            <span class="mask bg-gradient-black opacity-3" />
            <div class="container">
              <div class="row">
                <div class="col-lg-7 my-auto pt-4 px-5  p-md-6">
                  <h5 class="fadeIn1 fadeInBottom text-white">
                    教育科技
                  </h5>
                  <h3 class="mb-2 mb-md-4 fadeIn2 fadeInBottom text-white">
                    新北市教育局攜手VMware<br>導入VMware Tanzu Greenplum大數據平台
                  </h3>
                  <p class="opacity-8 fadeIn3 fadeInBottom text-white mb-0">
                    新北市教育局今年啟用全國首座雲端智慧科技中心，在VMware的協助下，採用VMware Tanzu Greenplum作為打造大數據平台的資料分析與軟體管理核心解決方案，驅動教與學的雙軸轉型。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="min-vh-60 position-absolute w-100 top-0">
        <a
          class="carousel-control-prev"
          href="#carouselExampleControls"
          role="button"
          data-bs-slide="prev"
        >
          <span
            class="carousel-control-prev-icon position-absolute bottom-50"
            aria-hidden="true"
          />
          <span class="visually-hidden">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExampleControls"
          role="button"
          data-bs-slide="next"
        >
          <span
            class="carousel-control-next-icon position-absolute bottom-50"
            aria-hidden="true"
          />
          <span class="visually-hidden">Next</span>
        </a>
      </div>
    </div>
  </header>

  <!-- Body Start -->

  <div class="container">
    <div class="d-flex border-radius-xl mt-3 mt-md-5 pb-4 w-100 p-0 p-md-3 mx-auto">
      <div class="col-12 col-md-9 col-lg-6 d-flex align-items-center mx-md-auto">
        <div class="input-group input-group-outline">
          <label class="form-label">新聞關鍵字</label>
          <input
            class="form-control"
            type="text"
          >
        </div>        
        <div class="ms-3">
          <button
            type="button"
            class="btn bg-gradient-dark w-100 mb-0"
          >
            Search
          </button>
        </div>
      </div>
    </div>
    <!--
      <div class="my-7 text-center">
          <img src="assets/img/search.png" class="max-width-200 mb-4">
            <h6 class="mb-3">沒有符合的搜尋結果</h6>
          <button class="btn btn-info">清除搜尋條件</button>
        </div>
-->
    <section class="py-md-5">
      <template v-if="p==1">
        <div class="card card-plain card-blog">
          <div class="row">
            <div 
              class="col-lg-4 col-md-5  position-relative"
              @click="drawPrivateModalPage"
            >
              <div
                class="nicole-member-center text-warning shadow"
                style="z-index: 99;cursor: pointer"
              >
                <i
                  class="fa-solid fa-circle-play  bg-white rounded-circle"
                  style="font-size: 4rem;"
                />
              </div>
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
              >
                <div class="blur-shadow-image ">
                  <img
                    class="img border-radius-lg imgnews"
                    src="@/assets/img/newmap12.png"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/examples/blog-post-1.jpg&quot;);"
                /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:12})"
                  class="text-dark"
                >昀揚科技於2024智慧城市展成功展示「TronMap Metaverse」全方位智慧園區管理解決方案</a>
              </h5> 
              <p>
                昀揚科技股份有限公司在「2024智慧城市展暨2050淨零城市展」中展示「TronMap Metaverse」全方位智慧園區管理解決方案獲得熱烈關注。<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:12})"
                  class="text-warning  pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2024年3月27日
                </p>
                <span class="badge bg-gradient-success ms-2 text-capitalize">創益圖 Tron Map</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card card-plain card-blog mt-5 mt-lg-6">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
                @click="goToPage('NewsItem',{nid:11})"
              >
                <div class="blur-shadow-image ">
                  <img
                    class="img border-radius-lg imgnews"
                    src="assets/img/city2.jpg"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/examples/blog-post-1.jpg&quot;);"
                /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:11})"
                  class="text-dark"
                >昀揚科技攜「TronMap Metaverse」於2024智慧城市展Smart City Summit & Expo展出</a>
              </h5> 
              <p>
                昀揚科技於2023年10月25日推出「TronMap Metaverse」，將於113年03月19日(四)至03月22日(五)在【2024智慧城市展Smart City Summit & Expo】台北南港展覽館2館 Q202 盛大展出。<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:11})"
                  class="text-warning  pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2024年03月04日
                </p>
                <span class="badge bg-gradient-success ms-2 text-capitalize">創益圖 Tron Map</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card card-plain card-blog mt-5 mt-lg-6">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
                @click="goToPage('NewsItem',{nid:10})"
              >
                <div class="blur-shadow-image ">
                  <img
                    class="img border-radius-lg imgnews"
                    src="assets/img/buildg.jpg"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/examples/blog-post-1.jpg&quot;);"
                /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:10})"
                  class="text-dark"
                >北市政府教育局-校舍管理系統，榮獲2023雲端物聯網創新獎之優良應用獎</a>
              </h5> 
              <p>
                恭賀新北市政府教育局榮獲「2023雲端物聯網創新獎之優良應用獎」，我司與新北市政府教育局合作開發之校舍管理系統為本次參與競賽之亮點平台之一！校舍管理系統為昀揚科技的「創益圖 TronMap」系列產品-「園區建築管理平台系統 ( BMMS Platform Node ) 」授權給新北市政府教育局，於新北市300所學校進行校園平面圖的繪圖、建築物相關資訊連結應用及管理。<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:10})"
                  class="text-warning  pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2023年11月23日
                </p>
                <span class="badge bg-gradient-success ms-2 text-capitalize">創益圖 Tron Map</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-plain card-blog mt-5 mt-lg-6">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
                @click="goToPage('NewsItem',{nid:9})"
              >
                <div class="blur-shadow-image ">
                  <img
                    class="img border-radius-lg imgnews"
                    src="assets/img/edtech2.jpg"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/examples/blog-post-1.jpg&quot;);"
                /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:9})"
                  class="text-dark"
                >2023教育科技展EdTech Taiwan開展，昀揚科技「TronEdu 創益學」您最佳的教育科技解決方案！</a>
              </h5> 
              <p>
                昀揚科技股份有限公司於教育科技產業深耕多年，持續研發教育科技解決方案，今年攜「TronEdu 創益學」、「TronMap 創益圖」、「TronSecurity 創益Security」 三大系列產品，於112年11月9日(四)至11月12日(日)在臺北資訊月【臺灣教育科技展】世貿一館盛大展出。<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:9})"
                  class="text-warning  pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2023年11月15日
                </p>
                <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu創益學</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card card-plain card-blog mt-5 mt-lg-6">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
                @click="goToPage('NewsItem',{nid:8})"
              >
                <div class="blur-shadow-image ">
                  <img
                    class="img border-radius-lg imgnews"
                    src="assets/img/bmms1.jpg"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/bmms1.jpg&quot;);"
                /><div class="colored-shadow" /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:8})"
                  class="text-dark"
                >一眼掌握雲端園區 監控管理好幫手：創益圖Tron Map</a>
              </h5> 
              <p>
                昀揚科技股份有限公司將於 2024 年 Q1 推出創益圖 Tron Map，
                近年來掌握「使用者應用生態圈」、透過以人為本的使用者行為與需求，結合智慧科技來創造最高價值的產業紛紛興起，
                在這一波智慧科技驅動資通訊產業的革命潮流中，
                為「園區管理」開啟了雲端化的新視野。<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:8})"
                  class="text-warning  pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2023年10月31日
                </p>
                <span class="badge bg-gradient-success ms-2 text-capitalize">創益圖 Tron Map</span>
              </div>
            </div>
          </div>
        </div>           
        <div class="card card-plain card-blog mt-5 mt-lg-6">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
                @click="goToPage('NewsItem',{nid:7})"
              >
                <div class="blur-shadow-image ">
                  <img
                    class="img border-radius-lg imgnews"
                    src="assets/img/tronedu-s.jpg"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/tronedu-s.jpg&quot;);"
                /><div class="colored-shadow" /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:7})"
                  class="text-dark"
                >雲端教材智慧整合 TronEdu創益學 為業界提供最佳選擇</a>
              </h5> 
              <p>
                昀揚科技股份有限公司將於 2024 年 Q1 推出 TronEdu 創益學平台（Curriculum Platform） 其擁有「智能雲端課程編排系統」、「智能出卷系統」、「智能排課系統」等人工智能應用相關獨家專利技術，
                使用者可透過昀揚科技的雲端資料中心更新教育部公佈每年最新版的知識架構與課綱，亦可應用在專業證照、教育訓練、高普考、幼兒等需求，客製化知識架構及課綱。
                數位管理有效為使用者解決不同課程版本無法統一教材內容而造成巨額維護成本與時間的難題。<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:7})"
                  class="text-warning  pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2023年10月31日
                </p>
                <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu創益學</span>
              </div>
            </div>
          </div>
        </div>            
        <div class="card card-plain card-blog mt-5 mt-lg-6">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
                @click="goToPage('NewsItem',{nid:6})"
              >
                <div class="blur-shadow-image ">
                  <img
                    class="img border-radius-lg imgnews"
                    src="assets/img/securitynews.jpg"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/securitynews.jpg&quot;);"
                /><div class="colored-shadow" /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:6})"
                  class="text-dark"
                >昀揚科技受邀參加 2023臺灣數位信任科技應用交流會</a>
              </h5> 
              <p>
                昀揚科技股份有限公司將於 2024 年 Q1 推出「創益Security（TronSecurity）」資訊安全的解決方案，
                與工研院資安整合服務平台（Security Platform as a Services , SECPAAS）以及歐生全 AuthenTrend三方進行技術轉移合作，
                提供使用者建立零信任架構（ZTA）中決策引擎「身分鑑別」的核心機制。<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:6})"
                  class="text-warning  pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2023年10月27日
                </p>
                <span class="badge bg-gradient-warning ms-2 text-capitalize">TronSecurity</span>
              </div>
            </div>
          </div>
        </div>            
        <div class="card card-plain card-blog mt-5 mt-lg-6">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
                @click="goToPage('NewsItem',{nid:5})"
              >
                <div class="blur-shadow-image ">
                  <img
                    class="img border-radius-lg imgnews"
                    src="assets/img/newsnt2.jpg"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/newsnt2.jpg&quot;);"
                /><div class="colored-shadow" /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:5})"
                  class="text-dark"
                >雲端題庫評量命題系統翻轉未來智慧教育 讓學校更Smart!!</a>
              </h5> 
              <p>
                新北市多年來持續以「智能城市」為施政目標，引用新科技提供市民便利生活，因而在面對「各學制多系統、教師數位能力養成、科技化學習環境需求、重視學生學習主體性」的挑戰下，以「未來智慧學校」揚升教與學之便利性及學校行政效能，引領各校邁向智慧校園。<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:5})"
                  class="text-warning  pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2023年6月20日
                </p>
                <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu 創意學</span>
              </div>
            </div>
          </div>
        </div>  
        <div class="card card-plain card-blog mt-5 mt-lg-6">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
                @click="goToPage('NewsItem',{nid:4})"
              >
                <div class="blur-shadow-image ">
                  <img
                    class="img border-radius-lg imgnews"
                    src="assets/img/cratream5.jpg"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/cratream5.jpg&quot;);"
                /><div class="colored-shadow" /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:4})"
                  class="text-dark"
                >CRStream Standard影音串流媒體服務開發與整合的最佳解決方案展</a>
              </h5> 
              <p>
                還在為高額的網路影音串流媒體服務煩惱嗎?還在擔心創作的影音內容被偽造盜用嗎?CRStream Standard提供您低成本又安全的影音串流媒體服務。<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:4})"
                  class="text-warning  pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2023年6月20日
                </p>
                <span class="badge bg-gradient-info ms-2 text-capitalize">CRStream 影音串流</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-plain card-blog mt-5 mt-lg-6">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
                @click="goToPage('NewsItem',{nid:3})"
              >
                <div class="blur-shadow-image ">
                  <img
                    class="img border-radius-lg imgnews"
                    src="assets/img/edu1.jpg"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/edu1.jpg&quot;);"
                /><div class="colored-shadow" /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:3})"
                  class="text-dark"
                >新北市教育局-教育成果</a>
              </h5> 
              <p>
                新北市教師善用數位學習工具，更關注學生的學習成效，因此建置命題評量模組，重視命題評量診斷，利用大數據的回饋審視校準學生每一步的學習，已學生為中心，為幸福而教。<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:3})"
                  class="text-warning  pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2023年6月20日
                </p>
                <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu 創意學</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="p==2">
        <!--
        <div class="card card-plain card-blog mt-5 mt-lg-6">
        -->
        <div class="card card-plain card-blog">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
                @click="goToPage('NewsItem',{nid:2})"
              >
                <div class="blur-shadow-image">
                  <img
                    class="img border-radius-lg imgnews"
                    src="assets/img/news1.jpg"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/news1.jpg&quot;);"
                />
                <div class="colored-shadow" /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:2})"
                  class="text-dark lh-base"
                >讓TronEdu EMS Essentials Plus解決您的命題煩惱</a>
              </h5>
              <p>
                老師們，是否還在為每次段考的命題任務感到困擾?是否還在擔心考題的方向不夠全面?這些煩惱讓Cloud Raise昀揚科技的TronEdu EMS Essentials Plus來幫你解決。<br>TronEdu EMS Essentials Plus是一套提供給老師和編輯人員處理命題、出卷、考試、分析、診斷等資訊應用服務需求的雲端產品，累積數年豐富的K12教育科技整合經驗，已廣泛使用於各大教育集團、地方政府及學校單位。<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:2})"
                  class="text-warning pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2023年3月29日
                </p>
                <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu 創意學</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-plain card-blog mt-5 mt-lg-6">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <a
                class="card-image position-relative border-radius-lg"
                href="javascript:;"
                @click="goToPage('NewsItem',{nid:1})"
              >
                <div class="blur-shadow-image ">
                  <img
                    class="img border-radius-lg imgnews"
                    src="assets/img/vmware.webp"
                  >
                </div>
                <div
                  class="colored-shadow"
                  style="background-image: url(&quot;assets/img/vmware.webp&quot;);"
                /><div class="colored-shadow" /></a>
            </div>
            <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
              <h5>
                <a
                  class="text-dark"
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:1})"
                >新北市教育局導入VMware Tanzu Greenplum大數據平台，推動智慧教育發展</a>
              </h5> 
              <p>
                新北市教育局發展智慧教育已行之有年，今年更宣佈啟用全國首座雲端智慧科技中心，並盼能透過大數據力量，極大化校務資料與學習評量等運用效益。在VMware的協助下，新北市教育局採用VMware Tanzu Greenplum作為打造大數據平台的資料分析與軟體管理核心解決方案，並預計自110年起至115年逐步推進四階段導入，驅動教與學的雙軸轉型<br>
                <a
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:1})"
                  class="text-warning  pt-1"
                > Read More </a>
              </p>
              <div class="author">
                <p class="my-auto">
                  2023年3月28日
                </p>
                <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu 創意學</span>
              </div>
            </div>
          </div>
        </div>
        
      </template>
    </section>
    <div class="mt-4">
      <nav
        aria-label="Page navigation example"
        class="mt-5"
      >
        <ul class="pagination justify-content-center">
          <li class="page-item">
            <a
              class="page-link"
              href="#news"
              v-smooth-scroll
              @click="prevPage()"
            >
              <i
                class="fa fa-angle-left"
                aria-hidden="true"
              />
              <span class="sr-only">Previous</span>
            </a>
          </li>

          <li 
            class="page-item"
            :class="{ 'active': p == 1 }"
          >
            <a
              class="page-link"
              :class="{ 'text-white': p == 1 }"
              @click="changePage(1)"
              href="#news"
              v-smooth-scroll
            >1
            </a>
          </li>
          <li
            class="page-item"
            :class="{ 'active': p == 2 }"
          >
            <a
              class="page-link"
              :class="{ 'text-white': p == 2 }"
              @click="changePage(2)"
              href="#news"
              v-smooth-scroll
            >2</a>
          </li>
          <li class="page-item">
            <a
              class="page-link"
              href="#news"
              v-smooth-scroll
              @click="nextPage()"
            >
              <i
                class="fa fa-angle-right"
                aria-hidden="true"
              />
              <span class="sr-only">Next</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <PrivateModalPage
    :privatePkyId="privatePkyId"
  />
  <!-- Body End -->
  <Footer />
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config, crstream } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame , oAdminFrame } from '@/lib/oltModule/initOltVue3';
//import Header from '@/components/Header.vue';
import { SideNav , Header , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { PrivateModalPage } from '@/components/Preview' ;

export default {
  name: 'App',
  components: {
    SideNav,
    //Header,
    //NavBar,
    // Settings,
    Footer,
    PrivateModalPage,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();


    /**
     * Change Page Start
     */
    const p = ref();
    //console.log('router.currentRoute.value : ', router.currentRoute.value.query);

    if(router.currentRoute.value.query.p == null || router.currentRoute.value.query.p == '' ){
      /*
      swal.fire({
        icon:'error',
        html:'路徑錯誤！！',
        buttonsStyling: true,
        confirmButtonClass: 'md-button md-success',
        //confirmButtonText:t('messages.confirm_button'),
      }).then( result => {
        if (result.value) {
          //console.log('result : ' , result);
          //emit('addCallBack');
          //router.go(-1);
          goToPage('/');
        }
      });
      */
      p.value= 1 ; 
    }
    else{
      p.value= router.currentRoute.value.query.p ; 
    }
    //console.log('p',p.value);
    function changePage(item) {
      //console.log('changePage : ' , p);
      p.value = item ; 
    }
    function nextPage() {
      if(p.value == 2 ){
        p.value == 2;
      }
      else{
        p.value = p.value + 1;
      }
    }
    function prevPage() {
      if(p.value == 1 ){
        p.value == 1;
      }
      else{
        p.value = p.value - 1;
      }
    }
    /**
     * Change Page End
     */


    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;

    function goToPage(pageItem,queryItem){
      if(router.currentRoute.value.name == pageItem) { return; }
      //router.push(page);
      //router.push({ path:'Home' , query:{page:1,blid:1}} );
      //console.log('pageItem : ', pageItem);
      router.push({ path:pageItem , query:queryItem} );
    }

    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    const privatePkyId = ref('0');
    const currentProtocol = window.location.protocol;
    const urlKey = ref(currentProtocol == 'http:' ? 'url' : 'urls');
    const demoVideo = ref();

    function drawPrivateModalPage(){
      privatePkyId.value = demoVideo.value[urlKey.value] ;
	  
      	// console.log("privatePkyId");
      	// console.log(privatePkyId.value );
	
      // eslint-disable-next-line no-undef
      $('#private').modal('show');
    }

    function guestLogin(){

      const apiParam = {
          restApiDriver: config.crStreamApiDriver ,// token key from veex store 
          // auth
          token: "",
          // Debug Mode 
          apiPostDebug: false, // API 新增 除錯模式
          apiName: "admin_guest_login",
          form: {
              id: crstream.id,
              secret: crstream.secret,
              domain: "",
          },
      };
      //console.log('apiParam : ', apiParam);
      let resObj = oAA.postRecordVue3(apiParam);
      resObj.then((res) => {
          //console.log('res : ', res);
          if (res["admin_guest_login"] && res["admin_guest_login"]['tokens'] && res["admin_guest_login"]['tokens']['token']) {
            getVideo(res["admin_guest_login"]['tokens']['token'], crstream.id, crstream.secret, "", "N");
          }
      }).catch((exception) => {
          console.log("exception : " + exception);
          // console.log(err.response.data);
      });
    }

    function getVideo(token, id, secret, account, isPrivate) {
        const apiParam = {
            restApiDriver: config.crStreamApiDriver ,// token key from veex store 
            // auth
            token: token, // token key from veex store 
            // Debug Mode 
            apiGetPageDebug: false, // API getPageRecord 除錯模式
            apiGetRtAllRecordDebug: false, // rtAllRecord Debug 
            apiGetRtPageRecordDebug: false, // API getRt 除錯模式        
            // API Filter 
            apiName: 'video_custom',
            pageNumber: 1, // int32 
            pageSize: 10, // int 32
            pageSort: 'seq', // string 
            pageSortBy: 'asc', // string 
            customFilter: false,
            pageSearch: {
                vid: 51,
            }, // json format 
            pageGroup: '', // string 
            pageGroupBy: '', // string 
            pageMode: true, // 是否打開換頁邏輯，若設定 fale 則預設只抓 1000 筆，參考 FunsController.php 。
            module: "", // module 
            fun: "video", // fun 
            act: 'view', // act  
            // rt 
            rtSet: {},
            queueSpeed: 1, // 異步 IO queue 的 順序執行間隔時間 1/1000 秒
        };
        oAA.queueGetAllVue3(apiParam)
            .then(
                res => {
                    if (res.pageRecord && res.pageRecord.data && res.pageRecord.data.length > 0) {
                        demoVideo.value = res.pageRecord.data[0];
                        //videoSrc.value = res.pageRecord.data[0][urlKey.value];
                        postVideoLinkHistory(token, {
                            vid: res.pageRecord.data[0]["vid"],
                            video_name: res.pageRecord.data[0]["name"],
                            id: id,
                            secret: secret,
                            account: account,
                            get_video_time: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss'),
                            year: moment(Date.now()).format('YYYY'),
                            month: moment(Date.now()).format('MM'),
                            day: moment(Date.now()).format('DD'),
                            hour: moment(Date.now()).format('HH'),
                            min: moment(Date.now()).format('mm'),
                        });
                    }
                }
            )
            .catch((err) => {
                oApiError.chkError(err, swal, t);
                //console.log(err);
            });
    }

        function postVideoLinkHistory(token, form){
            //console.log("[postVideoLinkHistory] form: ", form);
            const apiParam = {
                restApiDriver: config.crStreamApiDriver ,// token key from veex store 
                // auth
                token: token,
                // Debug Mode 
                apiPostDebug: false, // API 新增 除錯模式
                apiName: "video_link_history",
                form: form,
                fun: "VideoLinkHistory", // fun 
                act: 'view', // act 
            };
            let resObj = oAA.postRecordVue3(apiParam);
            resObj.then((res) => {
                //console.log('res : ', res);
            }).catch((exception) => {
                //console.log("exception : " + exception);
                //console.log(exception.response.data);
            });
        }
    guestLogin();



    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      p,
      privatePkyId,
      // function
      goToPage,
      chkLogin,
      changePage,
      nextPage,
      prevPage,
      drawPrivateModalPage
    };


  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
<style scoped>
.nicole-member-center :hover{
  transform: scale(1.2);
  transition: 0.5s;
}
</style>
